import { Component, inject, type OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvironmentService } from '@core/environment/environment.service';
import { SentryErrorService } from '@core/error/sentry-error.service';
import { TranslateService } from '@fino-ui/translation';
import Darkmode from 'darkmode-js';
import Keycloak from 'keycloak-js';
import { NgxLoadingModule } from 'ngx-loading';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AppService } from './app.service';
import { FreshdeskComponent } from './components/freshdesk/freshdesk.component';
import { NavbarComponent } from './components/navbar/navbar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.sass'],
  imports: [
    NavbarComponent,
    FreshdeskComponent,
    RouterOutlet,
    NgxLoadingModule,
  ],
})
export class AppComponent implements OnInit {
  private readonly localStorage = inject(LocalStorageService);
  private readonly sessionStorage = inject(SessionStorageService);
  private readonly translateService = inject(TranslateService);
  private readonly sentryErrorService = inject(SentryErrorService);
  private readonly appService = inject(AppService);
  private readonly envService = inject(EnvironmentService);
  private readonly authService = inject(Keycloak);

  title = 'x2-courier-ui';

  loadingSpinnerConfig = {
    primaryColour: '#000',
    backdropBorderRadius: '3px',
  };

  constructor() {
    const darkmode = new Darkmode({
      bottom: '15px',
      right: 'unset',
      left: '160px',
      time: '0.5s',
      label: '🌓',
    });
    darkmode.showWidget();
  }

  get loading() {
    return this.appService.loading;
  }

  ngOnInit() {
    const lang = this.localStorage.retrieve('language');
    if (lang) {
      this.translateService.use(lang);
    }

    if (this.envService.isDev) {
      const token = this.authService.token;
      this.sessionStorage.store('accessToken', token);
    }

    this.sentryErrorService.initSentry();
  }
}
